import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPasswordService } from './reset-password.service';
import { RegisterUser } from '../../models/user-center.model';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HelperMethods } from '../common/helper-methods.service';
import { HttpErrorResponse } from '@angular/common/http';


import { SharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
  _entityId: string = "";
  user : any;
  forgotPassword : string = ""; 
  showNewPassword = false;
  showConfirmPassword = false;
  resetPasswordForm: FormGroup = new FormGroup({
    newPassword: new FormControl('', [
      Validators.required,
      this.helperMethods.uppercaseValidator(),
      this.helperMethods.lowercaseValidator(),
      this.helperMethods.numberValidator(),
      this.helperMethods.SpecialCharValidator(),
      Validators.minLength(6),
    ]),
    confirmPassword: new FormControl('', [
      Validators.required,
      this.helperMethods.uppercaseValidator(),
      this.helperMethods.lowercaseValidator(),
      this.helperMethods.numberValidator(),
      this.helperMethods.SpecialCharValidator(),
      Validators.minLength(6),
    ])
  });
  header: string = "";

  constructor(
    private _route: ActivatedRoute,
    private resetPasswordService: ResetPasswordService,
    private toasterService: ToastrService,
    private router: Router,
    private helperMethods: HelperMethods,
    private sharedService: SharedService
  ) { }
  ngOnInit(): void {
    this.sharedService.preserveContrastModeAndClearLocalStorage();

    let id: string = "";
    this._route.queryParams.subscribe(params => {
      id = params['id'];
      this.forgotPassword = params['forgotPassword'];
    });
    this._entityId = id
    this.getUserDetails(this._entityId);
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  getUserDetails(userId: string){
    this.resetPasswordService.getUserDetailsByUserId(userId).subscribe((response: any)=>{
      this.user = response;
      if(this.forgotPassword == "0"){
        this.header = this.user.roleName ? "Set your password for " + this.user.roleName : "Set your password for Entity User";
      }
      else{
        this.header = "Reset your password";
      }
        if (this.user && this.user.isAccountActivated && this.forgotPassword == "0") {
          this.toasterService.success("Admin account already activated. Please log in with the registered email", "Success")
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 2000)
        }

        if (this.user && this.forgotPassword == "1" && !this.user.isPasswordForgotten) {
          this.toasterService.success("Admin account password has been reset. Please log in with the registered email", "Success")
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 2000)
        }
    }, (error: HttpErrorResponse) => {
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    });
  }

  redirectToSignIn() {
    this.router.navigate(['/login']);
  }

  resetPassword() {
    if (this.resetPasswordForm.controls['newPassword'].value != this.resetPasswordForm.controls['confirmPassword'].value) {
      this.toasterService.warning("Confirm password should be the same as the new password", "Incorrect");
      return;
    }

    let userDetails: RegisterUser = {
      emailId: this.user.email,
      password: this.resetPasswordForm.controls['newPassword'].value,
      isPasswordForgotten: false
    }

    this.resetPasswordService.resetPassword(userDetails).subscribe((response: any)=>{
      if(response.succeeded){
        this.toasterService.success("Password set successfully. Please log in with the registered email", "Success");
        setTimeout(()=>{
          this.redirectToSignIn();
        }, 2000)
      }
      else {
        const errorMessages: string[] = response.responseData ? [response.responseData] :
          response.errors.map((error: any) => error.description);
        this.toasterService.error(errorMessages.join(','), 'Error');
      }
    }, (errorResponse: HttpErrorResponse) => {
      if(errorResponse.error){
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }
}
